import styled, { css } from 'styled-components';
import theme from '../../theme';
import Menu from './Menu'; // Keep Menu import if used in styles

export const ContentContainer = styled.div`
  width: 100%;
  box-sizing: border-box;
  font-family: 'Fustat', ${theme.fonts.main};
  overflow-x: hidden;
`;

export const MainGrid = styled.div`
  display: grid;
  grid-template-columns: 207px 1fr;
  gap: 1.5rem;
  margin-bottom: 2rem;
  max-width: 100%;
  overflow-x: hidden;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`;

export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  @media (max-width: 1200px) {
    flex-direction: row;
    justify-content: center;
  }

  @media (max-width: 500px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const SummaryCard = styled.div`
  width: 207px;
  height: 232px;
  flex-shrink: 0;
  border-radius: 20px;
  border: 1px solid #E6E6E6;
  background: #FEFFFE;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  box-sizing: border-box;

  @media (max-width: 1200px) and (min-width: 501px) {
    flex: 1;
    max-width: 400px;
  }
`;

export const IconCircle = styled.div`
  width: 100px;
  height: 100px;
  flex-shrink: 0;
  background-color: #DCF3FF;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.5rem;

  img {
    width: 50%;
    height: 50%;
    object-fit: contain;
  }
`;

export const SummaryNumber = styled.div`
  height: 34px;
  flex-shrink: 0;
  color: #29435B;
  font-family: 'Fustat', ${theme.fonts.main};
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-align: center;
`;

export const SummarySubtitle = styled.div`
  height: 34px;
  flex-shrink: 0;
  color: #29435B;
  text-align: center;
  font-family: 'Fustat', ${theme.fonts.main};
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 0.25rem;
`;

export const GraphContainer = styled.div`
  flex-shrink: 0;
  border-radius: 20px;
  border: 1px solid #E6E6E6;
  background: #FEFFFE;
  padding: 0 1.5rem 1.5rem 1.5rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;

export const GraphHeader = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
`;

export const DataTypeSelector = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
`;

export const DataTab = styled.button`
  border: none;
  background: transparent;
  padding: 0.5rem 1rem;
  cursor: pointer;
  position: relative;
  font-family: 'Fustat', ${theme.fonts.main};
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  color: #29435B;
  border-radius: 3px;
  transition: transform 0.1s ease, background-color 0.2s ease;

  &:active {
    transform: scale(0.95);
  }

  ${props => props.isSelected && css`
    background: #DCF3FF;
    color: #38B6FF;
    height: 46px;
    flex-shrink: 0;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 20px;
      right: 20px;
      height: 5px;
      flex-shrink: 0;
      border-radius: 5px;
      background: #38B6FF;
    }
  `}
`;

export const TitleTimelineWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media (max-width: 1100px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
`;

export const TitleWithAction = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;

export const GraphTitle = styled.h3`
  height: 34px;
  flex-shrink: 0;
  color: #29435B;
  font-family: 'Fustat', ${theme.fonts.main};
  font-size: 23px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0 0 0.5rem 0;
  text-align: left;

  span {
    color: #38B6FF;
    font-family: 'Fustat', ${theme.fonts.main};
    font-size: 23px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

export const TimelineSelector = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const TimelineButton = styled.button`
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Fustat', ${theme.fonts.main};
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  ${props => props.isSelected ? css`
    background: #29435B;
    color: #FEFFFE;
  ` : css`
    background: #E6E6E6;
    color: #29435B;
  `}
`;

export const ChartWrapper = styled.div`
  flex-grow: 1;
  width: 100%;
  position: relative;
  padding-top: 1rem;
`;

export const TableTitle = styled.h2`
  height: 34px;
  flex-shrink: 0;
  color: #29435B;
  text-align: left;
  font-family: 'Fustat', ${theme.fonts.main};
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 0.5rem;
`;

export const TableContainer = styled.div`
  border-radius: 20px;
  border: 1px solid #E6E6E6;
  background: #FEFFFE;
  padding: 1rem;
  box-sizing: border-box;
  overflow-x: auto;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const Th = styled.th`
  height: 16px;
  flex-shrink: 0;
  color: #29435B;
  text-align: ${props => props.align || 'left'};
  font-family: 'Fustat', ${theme.fonts.main};
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding: 0.5rem;
  border-bottom: 1px solid #E6E6E6;
`;

export const Td = styled.td`
  padding: 0.75rem 0.5rem;
  font-size: 0.9rem;
  color: ${theme.colors.noir_clair};
  vertical-align: middle;
  text-align: ${props => props.align || 'left'};

  &:first-child {
    white-space: normal;
  }

  a {
    color: ${theme.colors.bleu_fonce};
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const Tr = styled.tr`
  &:not(:last-child) {
    border-bottom: 1px solid #f0f0f0;
  }
`;

export const RowNumberTh = styled(Th)`
  width: 40px;
  text-align: center;
  color: #aaa;
  font-weight: 500;
`;

export const RowNumberTd = styled(Td)`
  width: 40px;
  text-align: center;
  color: #9db0c4;
  font-weight: 500;
`;

// New Subtitle Component
export const GraphSubtitle = styled.p`
  color: #666;
  font-family: 'Fustat', ${theme.fonts.main};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.4;
  margin: -0.25rem 0 1rem 0;
  text-align: left;
  max-width: calc(100%);
  height: calc(14px * 1.4 * 2);
`;

// New component for the info text
export const InfoText = styled.p`
  font-size: 0.8rem;
  color: #666; // A subtle grey color
  margin-top: 1rem; // Add some space above it
  text-align: left;
  align-self: flex-start; // Align to the start (left) of the flex container
`;

export const ShowMoreButton = styled.button`
  background-color: transparent;
  border: 1px solid ${theme.colors.bleu_fonce};
  color: ${theme.colors.bleu_fonce};
  padding: 0.5rem 1.5rem;
  font-family: 'Fustat', sans-serif;
  font-size: 0.9rem;
  font-weight: 600;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${theme.colors.bleu_fonce};
    color: #fff;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const RefreshButton = styled.button`
  padding: 0.5rem 1rem;
  background-color: ${props => props.disabled ? '#e0e0e0' : theme.colors.bleu_fonce};
  color: white;
  border: none;
  border-radius: 8px;
  font-family: 'Fustat', sans-serif;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: background-color 0.2s;

  &:hover {
    background-color: ${props => !props.disabled && '#213547'};
  }
`;